import { render, staticRenderFns } from "./Directive1.vue?vue&type=template&id=87cecb66&scoped=true&"
import script from "./Directive1.vue?vue&type=script&lang=js&"
export * from "./Directive1.vue?vue&type=script&lang=js&"
import style0 from "./Directive1.vue?vue&type=style&index=0&id=87cecb66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cecb66",
  null
  
)

export default component.exports